
/* tslint:disable:quotemark */
import { defineMessages } from "react-intl";


const MESSAGES = defineMessages({
  configurationEditFolderCancel: {
    id: "ConfigurationEditFolder.cancel",
    defaultMessage: "Cancel",
  }, 
  configurationEditFolderHeading: {
    id: "ConfigurationEditFolder.heading",
    defaultMessage: "Edit Folder",
  },
  configurationEditFolderNestedHeading: {
    id: "ConfigurationEditFolderNested.heading",
    defaultMessage: "Edit Construction Phase",
  },
  configurationEditFolderConfirm: {
    id: "ConfigurationEditFolder.confirm",
    defaultMessage: "Confirm",
  },
  configurationEditBuildingNumber: {
    id: "BuildingNumber.number",
    defaultMessage: "Building Number",
  },
  configurationEditOpportunityNumber: {
    id: "OpportunityNumber.number",
    defaultMessage: "Opportunity Number",
  },
  configurationEditFolderName: {
    id: "FolderName.name",
    defaultMessage: "Folder Name",
  }
});

export default MESSAGES;